import { render, staticRenderFns } from "./OpenboxLaboral.vue?vue&type=template&id=05ccb794&"
import script from "./OpenboxLaboral.vue?vue&type=script&lang=js&"
export * from "./OpenboxLaboral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports